<template>
    <div id="chatai_index" class="page_container">
        <div :class="['page_body_wrapper']">
            <div class="page_body">
                <div class="page_aside" id="eventWrapper">
                    <div :class="['app_container', site_skin]">
                        <div class="app_list">
                            <div class="app_left">
                            <template v-for="app in appList">
                                <div :class="['app_item',{'active':app.id==selectApplication.id}]"  v-show="app.id==selectApplication.id">
                                    <div class="app_icon" @click="changeApp(app.id)">
                                        <img :src="'/static/skin/'+site_skin+'/'+(app.id==selectApplication.id?app.id:app.id+'-2')+'.png'" :alt="app.name">
                                    </div>
                                    <div class="app_info">
                                        <div class="app_name">{{ app.name }}</div>
                                        <div class="app_desc">{{ app.desc }}</div>
                                    </div>
                                </div>
                            </template>
                            <template v-for="app in appList">
                                <div :class="['app_item']" v-show="app.id!=selectApplication.id">
                                    <div class="app_icon" @click="changeApp(app.id)" >
                                        <img :src="'/static/skin/'+site_skin+'/'+app.id+'-2'+'.png'" :alt="app.name">
                                    </div>
                                </div>
                            </template>
                            </div>
                            <div class="top_right" @click="toggleVersion">
                                <span :class="['version_icon', site_skin]"></span>
                                <span>{{cur_ask_model}}</span>
                                <button class="toggle_btn">切换版本</button>
                            </div>
                        </div>
                        <div class="container_area">
                            <div class="area_box">
                                <textarea class="area_input" :placeholder="placeholder" :maxlength="maxlength" v-model="inputVal"></textarea>
                                <div class="words_count">{{inputVal.length}} / {{maxlength}}</div>
                            </div>
                            <div class="area_condition">
                                <div class="condition_item" v-if="selectCateId == 61">
                                    <div class="condition_label">语气：</div>
                                    <div class="condition_content">
                                        <span @click="writeForm.tone=item.name" :class="['condition_tag',{'active':writeForm.tone==item.name}]" v-for="item in toneList" :key="item.type">{{ item.name }}</span>
                                    </div>
                                </div>
                                <div class="area_bottom">
                                    <button class="clear_btn" @click="inputVal=''">清除</button>
                                    <button class="send_btn" :disabled="!inputVal" @click="sendMsg"><img class="write_icon" src="./img/app_write.png" alt="">开始写</button>
                                </div>
                            </div>
                        </div>
                        <div class="app_center">
                            <div class="app_nav">
                                <div class="nav_item">实例演示</div>
                            </div>
                            <div class="open_vip">
                                <template v-if="cur_ask_model=='Chat3.5'">
                                    <img class="vip_icon" :src="'/static/skin/'+site_skin+'/is_vip.png'" alt="">
                                    <div class="vip_text" v-if="userInfo.is_vip==1">Chat3.5会员到期时间：{{ userInfo.vip_end_date }}</div>
                                    <div class="vip_text"  v-else>可用创作次数：{{ userInfo.score_balance }}次，开通会员不限次数</div>
                                </template>
                                <template v-else>
                                    <img class="vip_icon" :src="'/static/skin/'+site_skin+'/gpt4vip.png'" alt="">
                                    <div class="vip_text">剩余：{{userInfo.word_balance}}字，购买4.0字数包，限时优惠中…</div>
                                </template>
                                <button class="pay_btn" @click="showVipPopup = true">点此购买</button>
                            </div>
                        </div>
                        <div class="example_part">
                            <div class="example_item" v-for="(ex,index) in appExmapleList" :key="ex.id">
                                <span class="example_num">实例{{ index+1 }}：</span>{{ ex.content }} <button class="use_btn" @click="inputVal=ex.content">使用</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="page_content">
                    <div :class="['content_body', site_skin]" ref="scrollWrap">
                        <template v-if="context_list.length==0">
                            <div class="tips-area">
                                <div class="tips-title" v-if="selectCateId == 60">写作主题</div>
                                <div class="tips-title" v-if="selectCateId == 61">改写原文</div>
                                <div class="tips-title" v-if="selectCateId == 62">补全原文</div>
                                <div class="textarea" v-if="selectCateId == 60">
                                    <div class="tg_content">请使用左侧AI写作功能进行创作吧！</div>
                                </div>
                                <div class="textarea" v-if="selectCateId == 61">
                                    <div class="tg_content">请使用左侧AI改写功能进行创作吧！</div>
                                </div>
                                <div class="textarea" v-if="selectCateId == 62">
                                    <div class="tg_content">请使用左侧内容补全功能进行创作吧！<br/>注意：需要补全内容 请使用英文状态下的 中括号 [] 替换！！！</div>
                                </div>
                            </div>
                        </template>
                        <template v-if="context_list.length>0 && selectCateId == 60">
                            <div class="tips-area">
                                <div class="tips-title">写作主题</div>
                                <div class="textarea">
                                    <div class="tg_content" v-html="context_list[0].renderTitleHtml||context_list[0].title"></div>
                                </div>
                                <div class="tips-title">
                                    写作提纲 <span class="tip" v-if="context_list.length==1">(如对提纲不满意，可自行编辑)</span>
                                </div>
                                <div class="textarea" v-if="context_list[0].loading||context_list.length>1">
                                    <div class="tg_content" v-html="context_list[0].renderHtml||context_list[0].content"></div>
                                </div>
                                <textarea class="tg_textarea" v-model="context_list[0].content" maxlength="1000" :auto-height='true' v-if="!context_list[0].loading&&context_list.length==1"></textarea>
                                <div class="btn-area" v-if="context_list[0].loading">
                                    <button class="btn_stop"  @click="stopNextReply(context_list[0])">停止生成</button>
                                    <div style="padding-top: 7px;padding-right: 10px;">
                                        <img class="loading-pic" src="./img/loading2.gif" alt="">
                                    </div>
                                </div>
                                <div class="btn-area" v-if="!context_list[0].loading">
                                    <button class="btn_renew" @click="addReset(context_list[0], 0)" v-if="context_list.length==1">重新生成</button>
                                    <button class="btn_copy" @click="saveData(context_list[0])" v-if="context_list.length==1">保存</button>
                                    <button class="btn_renew" @click="addNext(1)" v-if="context_list.length==1&&!context_list[0].loading">生成正文</button>
                                    <button class="btn_copy" @click="copytext(context_list[0].content)" v-if="context_list.length>1">复制</button>
                                </div>
                            </div>
                            <div class="body-area" v-if="context_list.length>1 && selectCateId == 60">
                                <template v-for="(item, index) in context_list">
                                    <div class="textarea"  v-if="index>0">
                                    
                                        <!-- <div>第{{ index }}段</div> -->
                                        <div  class="tg_content" v-html="item.renderHtml||item.content"></div>
                                        <div class="btn-area" v-if="!item.loading">
                                            <button class="btn_renew" @click="addReset(item, index)" v-if="context_list.length==index+1">重新生成</button>
                                            <button class="btn_copy" @click="copytext(item.content)">复制</button>
                                            <button class="btn_next" @click="addNext(index+1)" v-if="!item.loading&&context_list.length==index+1">继续生成下一段</button>
                                        </div>
                                        <div class="btn-area" v-else>
                                            <button class="btn_stop"  @click="stopNextReply(item)">停止生成</button>
                                            <div style="padding-top: 7px;padding-right: 10px;">
                                                <img class="loading-pic" src="./img/loading2.gif" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </template>
                            
                        <!--改写-->
                        <div class="tips-area" v-if="context_list.length>0 && selectCateId == 61">
                            <div class="tips-title">
                                改写原文
                            </div>
                            <div class="textarea">
                                <div class="tg_content" v-html="context_list[0].renderTitleHtml||context_list[0].title"></div>
                            </div>
                            <div class="tips-title">
                                改写结果
                            </div>
                            <div class="textarea">
                                <div class="tg_content" v-html="context_list[0].renderHtml||context_list[0].content"></div>
                            </div>
                            <div class="btn-area" v-if="context_list[0].loading">
                                <button class="btn_stop"  @click="stopNextReply(context_list[0])">停止生成</button>
                                <div style="padding-top: 7px;padding-right: 10px;">
                                    <img class="loading-pic" src="./img/loading2.gif" alt="">
                                </div>
                            </div>
                            <div class="btn-area" v-if="!context_list[0].loading">
                                <!-- <button class="btn_renew" @click="addReset(context_list[0], 0)" v-if="context_list.length==1">重新生成</button> -->
                                <button class="btn_copy" @click="copytext(context_list[0].content)">复制</button>
                            </div>
                        </div>
                        <!--补全-->
                        <div class="tips-area" v-if="context_list.length>0 && selectCateId == 62">
                            <div class="tips-title">
                                补全原文
                            </div>
                            <div class="textarea">
                                <div class="tg_content" v-html="context_list[0].renderTitleHtml||context_list[0].title"></div>
                            </div>
                            <div class="tips-title">
                                补全结果
                            </div>
                            <div class="textarea">
                                <div class="tg_content" v-html="context_list[0].renderHtml||context_list[0].content"></div>
                            </div>
                            <div class="btn-area" v-if="context_list[0].loading">
                                <button class="btn_stop"  @click="stopNextReply(context_list[0])">停止生成</button>
                                <div style="padding-top: 7px;padding-right: 10px;">
                                    <img class="loading-pic" src="./img/loading2.gif" alt="">
                                </div>
                            </div>
                            <div class="btn-area" v-if="!context_list[0].loading">
                                <!-- <button class="btn_renew" @click="addReset(context_list[0], 0)" v-if="context_list.length==1">重新生成</button> -->
                                <button class="btn_copy" @click="copytext(context_list[0].content)">复制</button>
                                
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="['page_right_aside',{'hide':!sldeShow}, site_skin]">
                    <div @click="sldeShow=!sldeShow" :class="['collapse_icon',sldeShow?'fold':'unfold']"></div>
                    <div :class="['aside_wrap',{'overhiden':!sldeShow}]">
                        <div class="slide-top" >创作记录</div>
                        <div class="slide-list">
                            <div class="dialog-list" v-if="dialog_list.length">
                                <div @click="selectDialog(index)" :class="['dialog-item',{'active':dialogIndex==index}]" v-for="(dia,index) in dialog_list" :key="index" v-if="dia.model==cur_ask_model && selectCateId==dia.cate_id">
                                    <div class="dialog-msg-icon dialog-icon"></div>
                                    <div class="dialog-msg-text"><input :ref="'titleInput'+index" @blur="saveDialog(dia)" class="dialog-msg-input" v-if="dia.editFlag" type="text" v-model="dia.title"><span v-else>{{ dia.title }}</span></div>
                                    <div v-show="dialogIndex==index" @click.stop="editDialog(dia,index)" class="dialog-edit-icon dialog-icon"></div>
                                    <div @click.stop="delDialog(dia, index)" class="dialog-del-icon dialog-icon"></div>
                                </div>
                            </div>
                            <div class="empty-dialog" v-else>
                                <div class="empty-icon"></div>
                                <div class="empty-text">暂无对话</div>
                            </div>
                        </div>
                        <div class="slide-bottom">
                            <div class="slide-btn" @click="clearDialog">
                                <img class="slide-btn-icon" :src="'/static/skin/'+site_skin+'/clear_icon.png'" />
                                <div class="slide-btn-text">清除创作记录</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vipconfirm v-if="vipConfirmVisible" :from="confirmFrom" @confirm="vipConfirm"></vipconfirm>
        <vippanel v-if="showVipPopup" :from="vipFrom" :type="vipOpenType" :showPopup.sync="showVipPopup" @confirm="vipPopupConfirm"></vippanel>
        <identify ref="refIdentify" @validate="validateCode"></identify>
    </div>
</template>
<script type="text/ecmascript-6">
    import VditorPreview from 'vditor/dist/method.min'
    import "vditor/dist/index.css"
	import fetchRequest from "../plugins/fetch.js"
    import vippanel from "COMPONENTS/VipPanel.vue"
    import vipconfirm from "COMPONENTS/VipConfirm.vue"
    import newusercoupon from "COMPONENTS/NewUserCoupon.vue"
    import identify from "COMPONENTS/Identify.vue"
    export default {
        components:{vippanel, vipconfirm, newusercoupon, identify },
        data() {
            return {
                inputVal:"",
                score:0,
				dialog_list:[],
				dialogIndex:0,
				controller:null,
                sending:false,
                sldeShow:true,
                showVipPopup:false,
                vipFrom:0,
                vipOpenType:1,
                vipConfirmVisible:false,
                selectApplication:{
                        id:60,
                        name:'AI写作',
                        desc:'用提纲引导机器人写长文，助你轻松完成万字论文。',
                        placeholder:'请输入一个写作主体描述(根据指定的主体,自动输出提纲,在继续生成正文)，如：春天的故事'
                },
                appList:[
                    {
                        id:60,
                        name:'AI写作',
                        desc:'用提纲引导机器人写长文，助你轻松完成万字论文。',
                        placeholder:'请输入一个写作主体描述(根据指定的主体,自动输出提纲,在继续生成正文)，如：春天的故事'
                    },
                    {
                        id:61,
                        name:'AI改写',
                        desc:'保持原义，大幅度修改，广泛用于优化、抄袭领域。',
                        placeholder:'请输入想要改写的文章内容（字数控制在1000字内，如超过1000字请分成多次提交）'
                    },
                    {
                        id:62,
                        name:'内容补全',
                        desc:'结合上下文内容，自动帮助你补全中间缺失的内容。',
                        placeholder:'请输入内容,使用中括号[]表示需要AI自动补全的部分'
                    }
                ],
                confirmFrom:0,
                cur_chat_id:0,
                cur_ask_model:"Chat3.5",
                change_model:false, // 模型切换
                appExmapleList:[],
                dialogData:[],
                context_list:[], // 正文列表
                section_num:0,
                toneList:[
                    {type:1,name:"严肃"},
                    {type:2,name:"高兴"},
                    {type:3,name:"调皮"},
                    {type:4,name:"沮丧"},
                    {type:5,name:"生气"},
                ],
                writeForm:{
                    tone:""
                },
                site_skin:''
            }
        },
        created() {
            this.site_skin = SiteSkin
            // this.getDialogList();
            this.getDemoData()
            this.getDialogGroup();
            this.score = this.$store.state.userInfo.score_balance || 0;
        },
        mounted(){
            let that = this;
            document.getElementById("eventWrapper").addEventListener("click",function(e){
                if(e.target.classList.contains("vipPopShow")){
                    that.vipOpenType = 1
                    that.showVipPopup = true;
                }else if(e.target.classList.contains("vipPopShowWord")){
                    that.showVipPopup = true;
                    that.vipOpenType = 2
                }
            })
            setTimeout(()=>{
                if(this.$store.state.userInfo.is_auth_bind == 0){
                    // this.$refs.refIerified.show();//实名认证弹窗
                }
            },1000)
            if(this.dialog_list.length > 0){
                this.$nextTick(()=>{
                    this.vditorRender();
                })
            }
        },
		watch:{
			dialog_list:{
				handler(val){
					if(val.length){
						localStorage.setItem("dialogCreateArray",JSON.stringify(val))
					}else{
						localStorage.removeItem("dialogCreateArray")
					}
				},
				deep: true
			}
		},
		computed:{
			currentDialog(){
                if(this.dialogIndex==0){
                    let flag = false
                    let i = 0
                    this.dialog_list.forEach((dia)=>{
                        if(dia.model == this.cur_ask_model && dia.cate_id == this.selectCateId){
                            this.dialogIndex = i
                            flag = true
                        }else{
                            i = i + 1
                        }
                    })
                    if(!flag){
                        this.dialogIndex = 0
                        return []
                    }
                }
				let dialog = this.dialog_list[this.dialogIndex];
                if(dialog){
                    this.confirmSelect(this.dialogIndex)
                }
				return dialog ? dialog.msgList : []
			},
			title(){
				let dialog = this.dialog_list[this.dialogIndex];
				return dialog ? dialog.title : "新的创作"
			},
            userInfo(){
                return this.$store.state.userInfo;
            },
            isLogin(){
                return this.$store.state.isLogin;
            },
            placeholder(){
                let leftStr = this.cur_ask_model == "Chat3.5" ? (this.userInfo.is_vip==1?'':this.isLogin==true?'（剩余'+this.userInfo.score_balance+'次数）':'') : (this.isLogin==true?'（剩余'+this.userInfo.word_balance+'字)':'');
                if(this.selectApplication){
                    return this.selectApplication.placeholder + leftStr;
                }
            },
            maxlength(){
                return this.cur_ask_model=='Chat3.5' ? 1000 : 4000
            },
            selectCateId(){
                return this.selectApplication?this.selectApplication.id:0
            }
		},
        methods: {
            checkLogin(){
                // 检查登录状态
                if(!this.isLogin){
                    this.$showLogin();
                    return false;
                }else{
                    return true;
                }
            },
            getDialogList(){
                let dialogArr = localStorage.getItem("dialogCreateArray");
                if(dialogArr){
                    dialogArr = JSON.parse(dialogArr);
                    console.log("dialogArr=", dialogArr)
                    dialogArr.forEach((dia)=>{
                        dia.msgList.forEach(msg=>{
                            if(msg.loading){
                                msg.loading = false;
                                // msg.content = "网络走丢了，请重新提问"
                                msg.content = ""
                            }
                        })
                    })
                }else{
                    dialogArr = [];
                }
                this.dialog_list = dialogArr;
            },
            getDialogGroup(){
                // 获取对话分组
                this.$http.get(`/front/chatai/chat/group/?ctype=${this.cur_ask_model}&cate_id=${this.selectCateId}`).then((res) => {
					if (res.status == 200) {
                        this.dialogData = res.data.data_list;
                        this.dialog_list = this.dialogData;
                        this.confirmSelect(0);
					} else {
                        this.$message.error(res.message)
					}
				})
            },
            getDemoData() {
                // 获取演示示例
                this.$http.get('/front/chatai/ask/?cate_id='+this.selectCateId+'&page=0').then((res) => {
                    if (res.status == 200) {
                        this.appExmapleList = res.data.data
                    }
                });
			},
            //新增对话
			addDialog(){
                if(!this.checkLogin()) return
				if(this.sending){
                    this.$confirm('本次作答没有完成，创建新创作将停止本次作答？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.sending = false;
                        try{
                            this.controller.abort();
                            this.controller = null;
                        }catch(e){}
                        this.confirmAdd();
                    })
				}else{
					this.confirmAdd();
				}
			},
            confirmAddByChangeModel(){
                // 切换模型时创建新创作
                // if(!this.checkLogin()) return
                console.log("切换模型时创建新创作")
                this.selectApplication = null
                this.getDemoData()
                let curIndex = -1
                this.dialog_list.forEach((element, index) => {
                    if(element.model == this.cur_ask_model && curIndex == -1 && element.cate_id == this.selectCateId){
                        curIndex = index
                    }
                });
                this.dialogIndex = curIndex
			},
			confirmAdd(){
                if(!this.checkLogin()) return
                let data = {
                    msgList: [],
                    title: "新的创作",
                    editFlag: false,
                    id:0,
                    ctype:this.cur_ask_model,
                    model:this.cur_ask_model,
                    cate_id:this.selectApplication?this.selectApplication.id:0
                }
                this.$http.post('/front/chatai/chat/group/', data).then((res) => {
					if (res.status == 200) {
                        //给新增的聊天添加id
						data.id=res.data.id
                        this.dialog_list.unshift(data)
					} else {
                        this.$toast(res.message)
					}
				})
				try{
					this.dialogIndex = 0;
					this.controller.abort();
					this.controller = null;
				}catch(e){}
			},
			delDialog(dia, index){
                if(!this.checkLogin()) return
                this.$confirm('确定要删除对话？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.dialog_list.splice(index,1);
                    this.dialogIndex = -1;
                    this.context_list = []
                    let i = 0
                    this.dialog_list.forEach((dia)=>{
                        if(dia.model == this.cur_ask_model && dia.cate_id == this.selectCateId){
                            this.dialogIndex = i
                        }else{
                            i = i + 1
                        }
                    })
                    if(this.dialogIndex>-1){
                        this.confirmSelect(this.dialogIndex)
                    }

                    this.$http.delete(`/front/chatai/chat/group/${dia.id}/`).then((res) => {
                    	if (res.status == 200) {
                            
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
                })
			},
            editDialog(dia, index){
                if(!this.checkLogin()) return
                dia.editFlag=true;
                this.$nextTick(()=>{
                    this.$refs['titleInput'+index][0].focus();
                })
            },
            saveDialog(dia){
                if(!this.checkLogin()) return
                dia.editFlag=false;
                this.$http.put(`/front/chatai/chat/group/${dia.id}/`, dia).then((res) => {
					if (res.status == 200) {
					} else {
                        this.$toast(res.message)
					}
				})
            },
			clearDialog(){
                if(!this.checkLogin()) return
                this.$confirm('确定要删除对话？', '提示', {
                    type: 'warning'
                }).then(() => {
                    let curDialogList = this.dialog_list.filter((pay)=>!(pay.model == this.cur_ask_model && pay.cate_id == this.selectCateId));
                    this.dialog_list = curDialogList;
                    this.dialogIndex = 0;
					this.scrollToBottom();
                    if(this.sending){
                        this.sending = false;
                        try{
                            this.controller.abort();
                            this.controller = null;
                        }catch(e){}
                    }
                    this.context_list = []
                    this.$http.delete(`/front/chatai/chat/group/?ctype=${this.cur_ask_model}&cate_id=${this.selectCateId}`).then((res) => {
                    	if (res.status == 200) {
                            
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
                })
			},
            //选择对话框
			selectDialog(index){
                if(!this.checkLogin()) return
				if(this.sending){
                    this.$confirm('本次作答没有完成，切换创作将停止本次作答？', '提示', {
                        type: 'warning'
                    }).then(() => {
                        this.sending = false;
                        try{
                            this.controller.abort();
                            this.controller = null;
                        }catch(e){}
                        this.confirmSelect(index);
                    })
				}else{
					this.confirmSelect(index);
				}
			},
			confirmSelect(index){
				try{
                    let dia = this.dialog_list[index];
                    this.context_list = []
                    if(this.selectApplication){
                        this.$http.get(`/front/chatai/chat/?group_id=${dia.id}`).then((res) => {
                           // 获取对话数据
                           this.context_list = []
                           res.data.item_list.forEach(element => {
                            let lastMsg = {
                                chat_id:element.chat_id,
                                title:element.question,
                                content:element.answer,
                                add_time:element.add_time,
                                loading:false,
                                group_id:element.group_id
                            }
                            this.renderHtml(lastMsg);
                            this.context_list.push(lastMsg)
                           });
                        })
                    }
                    this.dialogIndex = index;
                    this.vditorRender();
                    this.controller.abort();
                    this.controller = null;
				}catch(e){}
			},
            validateCode(code){
                if(code){
					this.submitQuestion({chat_id:this.cur_chat_id, code_num:code})
				}else{
                    this.$toast("请输入验证码");
				}
            },
            //发送消息
			async sendMsg(){
                if(!this.checkLogin()) return
                this.inputVal = this.inputVal.trim();
                localStorage.setItem("inputVal", this.inputVal);
                event.preventDefault();
				
				if(!this.inputVal){
                    this.$toast('请输入内容')
					return
				}
                
				if(this.sending){
                    this.$toast('请等待上次作答完成')
					return
				}
				let list = this.dialog_list;
                this.context_list = []
				if(this.context_list.length == 0){
					list.unshift({
						msgList:[],
						title:this.inputVal,
                        editFlag:false,
                        id:0,
                        model:this.cur_ask_model,
                        cate_id:this.selectApplication?this.selectApplication.id:0
					})
                    this.dialogIndex = 0
                    await this.$http.post('/front/chatai/chat/group/',{ title: this.inputVal, ctype:this.cur_ask_model, cate_id:this.selectApplication?this.selectApplication.id:0}).then((res) => {
                    	if (res.status == 200) {
                            //给新增的聊天添加id
                    		list[this.dialogIndex].id=res.data.id
                    	} else {
                            this.$toast(res.message)
                    	}
                    })
				}
                this.context_list.push({
                    chat_id:0,
                    title:this.inputVal,
                    content:"",
                    add_time:"",
                    loading:true,
                    group_id:list[this.dialogIndex].id
                })
				this.scrollToBottom()
				//发起请求
				let data = {
					cate_id:0,
					question: this.inputVal,
                    group_id:list[this.dialogIndex].id
				}
                if(this.selectApplication){
                    // 应用
                    data.cate_id = this.selectApplication.id
                }
				// 同步请求
				this.submitQuestion(data); 
			},
			submitQuestion(data){
				// 提交问题
				let that = this;
                data.question = this.inputVal
				this.sending = true;
				data.stream = 1; // 流式处理
                data.source = SiteSource;
                data.ask_model = this.cur_ask_model
                let lastMsg = this.context_list[this.context_list.length-1]
                this.$http.post('/front/chatai/chat/',data).then((res) => {
					if(res.status == 200){
                        this.cur_chat_id = res.data.chat_id;
						this.score = res.data.score;
						let is_code_valid = res.data.is_code_valid;
                        lastMsg.add_time = res.data.add_time
                        lastMsg.chat_id = res.data.chat_id
						if(this.score == 0 && this.cur_ask_model == "Chat3.5"){
                            this.context_list = []
							lastMsg.content = "您的次数已用尽，开通会员畅享无限对话";
							lastMsg.loading = false;
							this.sending = false;
                            this.vipConfirmVisible = true;
                            this.confirmFrom = 0
						}else if(this.score == 0 && this.cur_ask_model == "Chat4.0"){
                            this.context_list = []
							lastMsg.content = "您的字数包已用完，请充值字数包畅享4.0对话";
							lastMsg.loading = false;
							this.sending = false;
                            this.vipConfirmVisible = true;
                            this.confirmFrom = 2
						}else if(is_code_valid == 1){
							// 提示验证码
							this.$refs.refIdentify.show()
						}else if(is_code_valid == 4){
							// 验证码错误
							this.$refs.refIdentify.show()
							this.$toast("验证码错误");
						}else{
                            this.$refs.refIdentify.init()
							this.$refs.refIdentify.popClose()
				            this.inputVal = "";
							// 发送消息
							this.fetchMsg(res.data.chat_id, this.context_list.length-1)
						}
					}else{
						this.sending = false;
                        lastMsg.content = res.message;
                        lastMsg.loading = false;
					}
					this.scrollToBottom();
				})
			},
			fetchMsg(id, index) {
				let chat_ids = [];
                let form = [this.writeForm]
				this.controller = fetchRequest('/api/front/chatai/chat/stream/',{chat_id:id,section_num:this.section_num,form:form, chat_ids},(res,startFlag)=>{
                    let lastMsg = this.context_list[index]
					if(res == "JDYBLACK"){
						lastMsg.content = "智能AI机器人回答的的内容包含有违反中国法律法规的内容，请修改后重新提问！\n\n为了平台的健康绿色发展，请勿在平台内提问政治、色情相关的内容，感谢您的理解和支持！"
						this.sending = false;
						this.controller.abort();
						this.controller = null;
						this.renderHtml(lastMsg);
					}else if(res == "#end#"){
						this.sending = false;
						this.controller = null;
                        lastMsg.loading = false
                        this.renderHtml(lastMsg);
                        this.vipPopupConfirm()
					}else{
						if(startFlag){
							lastMsg.content = ""
						}
						lastMsg.content += res;
                        this.renderHtml(lastMsg);
						this.scrollToBottom();
					}
				});
			},
            renderHtml(lastMsg){
                VditorPreview.md2html(lastMsg.content).then(res=>{
                    this.$set(lastMsg,'renderHtml',res)
                    this.vditorRender();
		        })
                VditorPreview.md2html(lastMsg.title).then(res=>{
                    this.$set(lastMsg,'renderTitleHtml',res)
                    this.vditorRender();
		        })
            },
			//停止回复
			stopReply(msg){
				try{
					this.controller.abort();
					this.sending = false;
					this.controller = null;
                    if(!msg.content) msg.content = "您已停止接收回复~"
				}catch(e){}
			},
            copytext (text) {
                const el = document.createElement('textarea')
                el.setAttribute('readonly', 'readonly')
                el.style.position = 'absolute'
                el.style.left = '-9999px'
                el.value = text
                document.body.appendChild(el)
                el.select()
                document.execCommand('copy')
                document.body.removeChild(el)
                this.$toast("复制成功");
            },
            //确认去开通，显示开通弹窗
            vipConfirm(res){
                this.vipConfirmVisible = false
                if(res){
                    this.showVipPopup = true;
                    if(this.cur_ask_model =="Chat3.5"){
                        this.vipFrom = 1;
                        this.vipOpenType = 1
                    }else{
                        this.vipFrom = 1;
                        this.vipOpenType = 2
                    }
                }
            },
            vipPopupConfirm(){
                let invite_code = localStorage.getItem("invite_code")||"";
                this.$http.get('/front/my/profile/?invite_code='+ invite_code+'&app_id='+APP_ID).then(res =>{
                    if(res.status=='200'){
						this.$store.commit("setUserInfo",res.data);
                    }else{
                        this.$toast(res.message)
                    }
                })
            },
            appBack(){
                
            },
            
            scrollToBottom(){
                this.$nextTick(()=>{
                    let scrollWrap = this.$refs.scrollWrap;
                    scrollWrap.scrollTop = scrollWrap.scrollHeight;
                })
            },
            vditorRender(){
                this.$nextTick(()=>{
                    if(this.context_list.length){
                        VditorPreview.mindmapRender(this.$refs.scrollWrap)
                        VditorPreview.mathRender(this.$refs.scrollWrap)
                        VditorPreview.mermaidRender(this.$refs.scrollWrap)
                        VditorPreview.chartRender(this.$refs.scrollWrap)
                        VditorPreview.highlightRender(this.$refs.scrollWrap)
                        VditorPreview.codeRender(this.$refs.scrollWrap)
                        // this.scrollToBottom();
                    }
                })
            },
            stopNextReply(item){
				try{
                    this.sending = false
					this.controller.abort();
					this.loading = false;
					this.controller = null;
					item.loading = false
				}catch(e){}
			},
            changeApp(cate_id){
                // 切换应用
                if(this.sending){
                    this.$toast('请等待上次作答完成')
					return
				}
                this.appList.forEach(obj=>{
                    if(obj.id == cate_id){
                        this.selectApplication = obj
                    }
                })
                this.getDialogGroup()
                this.getDemoData()
            },
            saveData(item){
                // 保存提纲
                console.log(item)
                this.$http.put(`/front/chatai/chat/${item.chat_id}/`,{answer:item.content}).then((res) => {
                    this.$toast('保存成功')
                })
            },
            addReset(item, index){
                // 重写
                this.section_num = index
                let lastMsg = this.context_list[index]
                lastMsg.content = ""
                lastMsg.loading = true;
                // 发送消息
                this.fetchMsg(item.chat_id, index)
				this.scrollToBottom();
            },
            addNext(index){
                // 生成一段
                this.section_num = index
				let item = this.context_list[0]
                this.context_list.push({
                    chat_id:0,
                    title:this.inputVal,
                    content:"",
                    add_time:"",
                    loading:true
                })
				//发起请求
				let data = {
					cate_id:this.selectCateId,
					question: this.inputVal,
                    group_id:item.group_id,
                    parent_id:item.chat_id
				}
				// 同步请求
				this.submitQuestion(data); 
            },
            toggleVersion(){
                if(this.sending){
                    this.$toast('请等待上次作答完成')
					return
				}
                this.cur_ask_model = this.cur_ask_model == "Chat3.5" ? "Chat4.0" : "Chat3.5"
                if(this.cur_ask_model == "Chat3.5"){
                    this.vipOpenType = 1
                }else{
                    this.vipOpenType = 2
                }
                this.getDialogGroup()
            }
        },
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .page_container{
        display: flex;
        width: 100%;
        height: 100%;
        min-height: 600px;
        background-color: #fff;
        overflow: hidden;
        flex-direction: column;
        
        .page_header{
            height: 60px;
            background-color: #dbefe4;
            flex-grow: 0;
            flex-shrink: 0;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            box-shadow: 0 4px 6px -1px #cecece,0 2px 4px -2px #cecece;
            .header_left{
                display: flex;
                align-items: center;
                .header_logo{
                    // width: 120px;
                    height: 45px;
                    margin-right: 20px;
                }
            }
            .fold{
                background-image: url("./img/menu_fold.png");
            }
            .unfold{
                background-image: url("./img/menu_unfold.png");
            }
        }
        .page_body_wrapper{
            flex-grow: 1;
            overflow: hidden;
            padding: 16px;
            .page_body{
                height: 100%;
                overflow: hidden;
                display: flex;
                box-shadow: 0 4px 6px -1px #ccc,0 2px 4px -2px #ccc;
                border: 1px solid #e5e7eb;
                border-radius: 6px;
                .page_aside{
                    // border-right: 1px solid #e5e7eb;
                    overflow-y: auto;
                    width: 620px;
                    flex-shrink: 0;
                    padding: 0 16px;
                    .app_container{
                        .app_list{
                            height: 68px;
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            .app_left{
                                display: flex;
                            }
                            .app_item{
                                display: flex;
                                align-items: center;
                                &.active{
                                    flex-grow: 1;
                                    .app_icon{
                                        margin-right: 10px;
                                    }
                                }
                                &:not(:last-child){
                                    margin-right: 10px;
                                }
                                .app_icon{
                                    display: flex;
                                    flex-grow: 1;
                                    width: 36px;
                                    height: 36px;
                                    flex-shrink: 0;
                                    img{
                                        display: block;
                                        width: 36px;
                                        height: 36px;
                                        cursor: pointer;
                                    }
                                }
                                .app_info{
                                    flex-grow: 1;
                                    .app_name{
                                        font-size: 14px;
                                        line-height: 23px;
                                    }
                                    .app_desc{
                                        font-size: 11px;
                                        line-break: 21px;
                                        color: #999;
                                    }
                                }
                            }
                            .top_right{
                                width: 160px;
                                height: 36px;
                                border: 1px solid #18a058;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 12px;
                                cursor: pointer;
                                color: #18a058;
                                border-radius: 2px;
                                .version_icon{
                                    width: 20px;
                                    height: 20px;
                                    display: inline-block;
                                    vertical-align: middle;
                                    background-size: 100% 100%;
                                    background-image: url("./img/version.png");
                                    margin: -3px 5px 0 0;
                                }
                                .black{
                                    background-image: url("/static/skin/black/version.png");
                                }
                                .toggle_btn{
                                    width: 58px;
                                    height: 22px;
                                    background-color: #18a058;
                                    color: #fff;
                                    border: none;
                                    border-radius: 2px;
                                    font-size: 12px;
                                    margin-left: 12px;
                                }
                            }
                        }
                        .container_area{
                            border: 1px solid #edeef7;
                            border-radius: 5px;
                            background-color: #f5f6fb;
                            .area_box{
                                position: relative;
                                .area_input{
                                    display: block;
                                    width: 100%;
                                    height: 132px;
                                    padding: 16px 20px;
                                    border: none;
                                    background-color: #f5f6fb;
                                }
                                .words_count{
                                    position: absolute;
                                    right: 20px;
                                    bottom: 0;
                                    line-height: 34px;
                                    font-size: 12px;
                                    color: #ccc;
                                }
                            }
                            .area_condition{
                                border-top: 1px solid #edeef7;
                                .condition_item{
                                    height: 60px;
                                    display: flex;
                                    align-items: center;
                                    padding: 0 16px;
                                    font-size: 14px;
                                    .condition_label{
                                        flex-shrink: 0;
                                        width: 45px;
                                    }
                                    .condition_content{
                                        flex-grow: 1;
                                        .condition_tag{
                                            cursor: pointer;
                                            display: inline-block;
                                            padding: 0 10px;
                                            height: 28px;
                                            line-height: 28px;
                                            font-size: 12px;
                                            color: #999;
                                            background-color: #dce0f1;
                                            border-radius: 3px;
                                            text-align: center;
                                            &:not(:last-child){
                                                margin-right: 10px;
                                            }
                                            &.active{
                                                color: #fff;
                                                background-color: #18a058;
                                            }
                                        }
                                    }
                                }
                                .area_bottom{
                                    height: 65px;
                                    border-top: 1px solid #edeef7;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    padding: 0 16px;
                                    .clear_btn{
                                        border: none;
                                        width: 90px;
                                        height: 34px;
                                        font-size: 14px;
                                        color: #999;
                                        background-color: #dce0f1;
                                        border-radius: 4px;
                                    }
                                    .send_btn{
                                        width: 123px;
                                        height: 34px;
                                        background-color: #18a058;
                                        border: none;
                                        color: #fff;
                                        font-size: 14px;
                                        border-radius: 2px;
                                        &:disabled{
                                            cursor: not-allowed;
                                            opacity: 0.6;
                                        }
                                        .write_icon{
                                            width: 18px;
                                            margin-right: 12px;
                                            vertical-align: middle;
                                            margin-top: -4px;
                                        }
                                    }
                                }
                            }
                        }
                        .app_center{
                            display: flex;
                            justify-content: space-between;
                            margin: 14px 0;
                            font-size: 14px;
                            line-height: 54px;
                            .app_nav{
                                flex-shrink: 0;
                                .nav_item{
                                    border-bottom: 1px dotted #18a058;
                                    color: #18a058;
                                    margin-right: 16px;
                                }
                            }
                            .open_vip{
                                color: #18a058;
                                border-bottom: 1px dotted #18a058;
                                width: 435px;
                                display: flex;
                                align-items: center;
                                overflow: hidden;
                                .vip_icon{
                                    width: 18px;
                                    height: 18px;
                                    display: block;
                                    margin-right: 10px;
                                    flex-shrink: 0;
                                }
                                .vip_text{
                                    flex-grow: 1;
                                    font-size: 12px;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                }
                                .pay_btn{
                                    flex-shrink: 0;
                                    width: 58px;
                                    height: 22px;
                                    border: none;
                                    background-color: #cff8e2;
                                    font-size: 12px;
                                    border-radius: 2px;
                                    color: #18a058;
                                }
                            }
                        }
                        .example_part{
                            .example_item{
                                margin-bottom: 12px;
                                font-size: 14px;
                                line-height: 24px;
                                color: #505673;
                                &:hover{
                                    .use_btn{
                                        display: inline-block;
                                    }
                                }
                                .example_num{
                                    font-weight: bold;
                                }
                                .use_btn{
                                    margin-left: 20px;
                                    height: 20px;
                                    padding: 0 8px;
                                    font-size: 12px;
                                    color: #18a058;
                                    border: 1px dotted #18a058;
                                    background-color: transparent;
                                    border-radius: 2px;
                                    display: none;
                                }
                            }
                        }
                    }
                    .black{
                        .app_list {
                            .top_right{
                                color: #000;
                                border: 1px solid #000;
                                .toggle_btn{
                                    background-color: #000;
                                }
                            }               
                        } 
                        .app_center{
                            .app_nav{
                                .nav_item{
                                    border-bottom: 1px dotted #333;
                                    color: #333;
                                }
                            }
                            .open_vip{
                                border-bottom: 1px dotted #333;
                                .vip_text{
                                    color: #333;
                                }
                                .pay_btn{
                                    background-color: #eee;
                                    color: #333;
                                }
                            }
                        }        
                        .container_area {
                            .area_condition{
                                .area_bottom {
                                    .send_btn{
                                        background-color: #000;
                                    }
                                }
                            }
                        }
                    }
                }
                .page_content{
                    flex-grow: 1;
                    overflow: hidden;
                    // overflow-y: auto;
                    background-color: #f5f6fb;
                    border: 1px solid #edeef7;
                    border-radius: 5px;
                    margin-top: 10px;
                    margin-right: 15px;
                    .content_body{
                        overflow-y: scroll;
                        padding: 10px;
                        margin-right: -17px;
                        height: 100%;
                    }
                }
                .page_right_aside{
                    width: 260px;
                    flex-shrink: 0;
                    border-left: 1px solid #e5e7eb;
                    transition: width 0.3s;
                    position: relative;
                    &.hide{
                        width: 0;
                    }
                    .collapse_icon{
                        position: absolute;
                        top: 50%;
                        margin-top: -12px;
                        left: -12px;
                        width: 24px;
                        height: 24px;
                        background-color: #fff;
                        border-radius: 50%;
                        border: 1px solid #e5e7eb;
                        box-shadow: 0 0 4px 2px #eee;
                        cursor: pointer;
                        &::after{
                            content: "";
                            width: 7px;
                            height: 7px;
                            border: 1px solid #666;
                            border-top: none;
                            border-right: none;
                            position: absolute;
                            top: 7px;
                            transform-origin: center center;
                        }
                        &.fold::after{
                            transform: rotate(225deg);
                            left: 6px;
                        }
                        &.unfold::after{
                            transform: rotate(45deg);
                            left: 8px;
                        }
                    }
                    .aside_wrap{
                        height: 100%;
                        padding: 16px 0;
                        display: flex;
                        flex-direction: column;
                        box-shadow: 0 0 14px 4px #ccc;
                        &.overhiden{
                            overflow: hidden;
                        }
                        .slide-top{
                            flex-grow: 0;
                            flex-shrink: 0;
                            cursor: pointer;
                            border-radius: 5px;
                            border: 1px dashed #379a63;
                            height: 46px;
                            padding: 12px 0;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            color: #379a63;
                            font-size: 13px;
                            user-select: none;
                            overflow: hidden;
                            margin: 0 16px;
                            white-space: nowrap;
                        }
                        .slide-list{
                            flex-grow: 1;
                            overflow: hidden;
                            padding: 12px 0;
                            height: 0;
                            .dialog-list{
                                overflow-y: scroll;
                                margin-right: -17px;
                                height: 100%;
                                padding: 0 16px;
                                .dialog-item{
                                    margin-bottom: 10px;
                                    display: flex;
                                    align-items: center;
                                    padding: 13px;
                                    border-radius: 5px;
                                    overflow: hidden;
                                    border: 1px solid #e5e7eb;
                                    cursor: pointer;
                                    &:hover{
                                        box-shadow: 0 0 3px 0px #acedc9;
                                        border-color: #acedc9;
                                    }
                                    &.active{
                                        border-color: #379a63;
                                        color: #379a63;
                                        .dialog-msg-icon{
                                            background-image: url("./img/chat_icon_active.png");
                                        }
                                        .dialog-del-icon{
                                            background-image: url("./img/delete_icon_active.png");
                                        }
                                    }
                                    .dialog-icon{
                                        width: 20px;
                                        height: 20px;
                                        flex-shrink: 0;
                                    }
                                    .dialog-msg-icon{
                                        margin-bottom: -2px;
                                        background-image: url("./img/chat_icon.png");
                                    }
                                    .dialog-msg-text{
                                        font-size: 13px;
                                        margin-left: 6px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        flex-grow: 1;
                                        .dialog-msg-input{
                                            width: 100%;
                                            height: 20px;
                                            border: 1px solid #e5e7eb;
                                            border-radius: 3px;
                                            padding: 0 8px;
                                            font-size: 12px;
                                        }
                                    }
                                    .dialog-del-icon{
                                        margin-left: 8px;
                                        background-image: url("./img/delete_icon.png");
                                    }
                                    .dialog-edit-icon{
                                        margin-left: 8px;
                                        background-image: url("./img/edit.png");
                                    }
                                }
                            }
                            .empty-dialog{
                                padding-top: 32px;
                                .empty-icon{
                                    width: 30px;
                                    height: 30px;
                                    margin: 0 auto;
                                    background-image: url("./img/dialog_empty.png");
                                }
                                .empty-text{
                                    font-size: 12px;
                                    color: #ccc;
                                    line-height: 40px;
                                    text-align: center;
                                }
                            }
                        }
                        .slide-bottom{
                            flex-grow: 0;
                            flex-shrink: 0;
                            padding: 0 16px;
                            .slide-btn{
                                height: 46px;
                                display: flex;
                                align-items: center;
                                padding-left: 24px;
                                background-color: #dbefe4;
                                margin-bottom: 12px;
                                cursor: pointer;
                                border-radius: 5px;
                                position: relative;
                                white-space: nowrap;
                                &:last-child{
                                    margin-bottom: 0;
                                }
                                .slide-btn-icon{
                                    width: 16px;
                                    height: 16px;
                                }
                                .slide-btn-text{
                                    color: #379a63;
                                    font-size: 14px;
                                    margin-left: 9px;
                                }
                            }
                        }
                    }
                }
                .black{
                   
                   .collapse_icon{
                       position: absolute;
                       top: 50%;
                       margin-top: -12px;
                       right: -12px;
                       width: 24px;
                       height: 24px;
                       background-color: #fff;
                       border-radius: 50%;
                       border: 1px solid #e5e7eb;
                       box-shadow: 0 0 4px 2px #eee;
                       cursor: pointer;
                       &::after{
                           content: "";
                           width: 7px;
                           height: 7px;
                           border: 1px solid #666;
                           border-top: none;
                           border-right: none;
                           position: absolute;
                           top: 7px;
                           transform-origin: center center;
                       }
                       &.fold::after{
                           transform: rotate(45deg);
                           left: 8px;
                       }
                       &.unfold::after{
                           transform: rotate(225deg);
                           left: 7px;
                       }
                   }
                   .aside_wrap{
                       .slide-top{
                           border: 1px dashed #ccc;
                           color: #333;
                       }
                       .slide-list{
                           .dialog-list{
                               .dialog-item{
                                   border: 1px solid #e5e7eb;
                                   background-color: #f5f5f5;
                                   color: #333;
                                   &:hover{
                                       box-shadow: 0 0 3px 0px #ccc;
                                       border-color: #ccc;
                                   }
                                   &.active{
                                       background-color: #fff;
                                       border-color: #ccc;
                                       color: #333;
                                       .dialog-msg-icon{
                                           background-image: url("./img/chat_icon.png");
                                       }
                                       .dialog-del-icon{
                                           background-image: url("./img/delete_icon.png");
                                       }
                                   }
                                   .dialog-edit-icon{
                                        margin-left: 8px;
                                        background-image: url("/static/skin/black/edit.png");
                                    }
                               }
                           }
                           .empty-dialog{
                               .empty-icon{
                                   width: 30px;
                                   height: 30px;
                                   margin: 0 auto;
                                   background-image: url("./img/dialog_empty.png");
                               }
                               .empty-text{
                                   font-size: 12px;
                                   color: #ccc;
                                   line-height: 40px;
                                   text-align: center;
                               }
                           }
                       }
                       .slide-bottom{
                           .slide-btn{
                               background-color: #eee;
                               .slide-btn-text{
                                   color: #333;
                               }
                           }
                       }
                   }
               }
            }
        }
    }
	@keyframes rotate {
	    0% {
			transform: rotate(0deg);
		}
		25% {
			transform: rotate(90deg);
		}
		50% {
			transform: rotate(180deg);
		}
		75% {
			transform: rotate(270deg);
		}
		100% {
			transform: rotate(360deg);
		}
	}
    @keyframes cursor-animation{
        0%{opacity:0}
        50%{opacity:1}
        to{opacity:0}
    }
    .tips-area,.body-area {
        .loading-pic{
            width: 20px;
            height: 20px;
        }
        .tips-title {
            font-size: 16px;
            // font-weight: 700;
            color: #333;
    
            .tips {
                margin-left: 10px;
                font-size: 13px;
                font-weight: 400;
                color: #9b9b9b;
            }
            .tip{
                margin-left: 10px;
                font-size: 13px;
                color: #9b9b9b;
                font-weight: normal;
            }
        }
    
        .textarea {
            margin: 15px 0;
            padding: 10px;
            border-radius: 10px;
            box-shadow: 0px 2px 14px 1px rgba(0, 0, 0, .08);
            font-size: 14px;
            font-weight: 400;
            color: #505673;
            background-color: #fff;
           
            .loading-tips{
                display: flex;
                align-items: center;
                margin-left:-20px;
                .loading-pic{
                    width: 84px;
                    height: 60px;
                }
                .loading-text{
                    color: #999;
                    font-size: 28px;
                }
            }
            textarea {
                width: 100%;
                height: 250px;
                border: 1px solid #dcdfe6;
                border-radius: 10px;
                line-height: 32px;
                color: #333;
                padding: 0 15px;
            }
        }
        .tg_textarea{
            margin-top: 10px;
            width: 100%;
            height: 250px;
            border: 1px solid #dcdfe6;
            border-radius: 10px;
            // line-height: 32px;
            color: #333;
            padding: 0 15px;
            font-size: 14px;
        }
        .tg_content{
            line-height: 32px;
            padding: 0 15px;
        }
        .btn-area{
            margin-top: 20px;
            display: flex;
        }
        .btn_renew{
            border: none;
            width: 90px;
            height: 34px;
            font-size: 14px;
            color: #fff;
            background-color: #18a058;
            border-radius: 4px;
            margin-right: 20px;
        }
        .btn_next{
            border: none;
            width: 120px;
            height: 34px;
            font-size: 14px;
            color: #fff;
            background-color: #18a058;
            border-radius: 4px;
            margin-right: 20px;
        }
        .btn_copy{
            border: none;
            width: 90px;
            height: 34px;
            font-size: 14px;
            color: #fff;
            background-color: #18a058;
            border-radius: 4px;
            margin-right: 10px;
        }
        .btn_stop{
            border: none;
            width: 90px;
            height: 34px;
            font-size: 14px;
            color: #fff;
            background-color: #18a058;
            border-radius: 4px;
            margin-right: 10px;
        }
    }
    .black{
        .tips-area, .body-area{
            .btn_renew{
                color: #fff;
                background-color: #000;
            }
            .btn_next{
                color: #fff;
                background-color: #000;
            }
            .btn_copy{
                color: #fff;
                background-color: #000;
            }
            .btn_stop{
                color: #fff;
                background-color: #000;
            }
        }
    }
</style>